export const validLocales = [
  'es',
  'en',
  'my',
  'vi',
  'he'
]
